import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  gapX?: 0 | 2 | 4 | 8 | 16
  gapY?: 0 | 2 | 4 | 8
  direction?: 'horizon' | 'vertical'
  align?: 'start' | 'center' | 'baseline' | 'end'
  justify?: 'start' | 'center' | 'end' | 'between'
  nowrap?: boolean
  full?: boolean
  remnant?: boolean
  inline?: boolean
}

const ItemAlign = ({
  children,
  gapX = 8,
  gapY = 0,
  direction = 'horizon',
  align = 'baseline',
  justify = 'start',
  nowrap = false,
  full = false,
  remnant = false,
  inline = false
}: Props) => {
  const gapXClass = gapX && gapX / 4
  const gapYClass = gapY && gapY / 4
  return (
    <>
      <div
        className={clsx(
          inline ? 'inline-flex' : 'flex',
          `gap-x-${gapXClass}`,
          direction == 'vertical' && 'flex-col',
          `items-${align}`,
          `justify-${justify}`,
          nowrap ? 'flex-nowrap' : 'flex-wrap',
          gapY && `gap-y-${gapYClass}`,
          full && 'w-full',
          remnant && 'min-w-0 flex-1'
        )}
      >
        {children}
      </div>
    </>
  )
}

export default ItemAlign
